import { render, staticRenderFns } from "./AddPerfil.vue?vue&type=template&id=0d14219f&scoped=true"
import script from "./AddPerfil.vue?vue&type=script&lang=js"
export * from "./AddPerfil.vue?vue&type=script&lang=js"
import style0 from "./AddPerfil.vue?vue&type=style&index=0&id=0d14219f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d14219f",
  null
  
)

export default component.exports